
import Rest from './Rest';

export class LabsService {

  static async getLabs(params){
    return Rest.post(`/lab/list`, params)
      .then(response => {
        return response.data;  
      })
      .catch(error => {
        console.error('Error of getting lab list:', error.response?.data || error.message);
        throw error;
    });
  }

  static async fetchLabDetail(labId){
    return Rest.post(`/lab/detail`, { lab_id: labId })
      .then(response => {
        return response.data;  
      })
      .catch(error => {
        console.error('Error of getting lab details:', error.response?.data || error.message);
        throw error;
    });
  }

  static async getLabList(){
    return Rest.get(`/lab/options`)
      .then(response => {
        return response.data;  
      })
      .catch(error => {
        console.error('Error of getting holiday list:', error.response?.data || error.message);
        throw error;
    });
  }

  static async getHolidayList(params) {

    return Rest.post(`/lab-holiday/list`, params)
      .then(response => {
        return response.data;  
      })
      .catch(error => {
        console.error('Error of getting holiday list:', error.response?.data || error.message);
        throw error;
    });

  }

  static async fetchHolidayDetail(holidayId) {

    return Rest.post(`/lab-holiday/detail`, { holiday_id: holidayId })
      .then(response => {
        return response.data;  
      })
      .catch(error => {
        console.error('Error of fetching holiday detail:', error.response?.data || error.message);
        throw error;
    });

  }

  static async addLab(details){
    return Rest.post(`/lab/add`, details)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error('Error while adding lab holiday', error);
      throw error;
    });
  }

  static async updateLab(updateData){
    return Rest.post(`/lab/update`, updateData)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error('Error while adding lab', error);
      throw error;
    });
  }

  static async deleteLab(labId) {
    return Rest.post(`/lab/delete`, { lab_id: labId })
      .then(response => {
        return response.data;  
      })
      .catch(error => {
        console.error('Error deleting lab:', error.response?.data || error.message);
        throw error;
    });
  }


  static async addHoliday(holidayDetails){
    return Rest.post(`/lab-holiday/add`, holidayDetails)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error('Error while adding lab holiday', error);
      throw error;
    });
  }

  static async updateHoliday(holidayDetails){
    return Rest.post(`/lab-holiday/update`, holidayDetails)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.error('Error while updating lab holiday', error);
      throw error;
    });
  }

  static async deleteLabHoliday(holidayId) {
    return Rest.post(`/lab-holiday/delete`, { holiday_id: holidayId })
      .then(response => {
        return response.data;  
      })
      .catch(error => {
        console.error('Error deleting lab holiday:', error.response?.data || error.message);
        throw error;
    });
  }

  static async days() {
    return [
      { id: 'Sunday', label: 'Sunday' },
      { id: 'Monday', label: 'Monday' }, 
      { id: 'Tuesday', label: 'Tuesday' }, 
      { id: 'Wednesday', label: 'Wednesday' }, 
      { id: 'Thursday', label: 'Thursday' }, 
      { id: 'Friday', label: 'Friday' }, 
      { id: 'Saturday', label: 'Saturday' }, 
    ];
  }

}